//#region Util Imports

import * as $ from 'jquery'

//#endregion

import { IReferenceType, IOpChangeState, IJsonSerializable } from '../util/interfaces'
import { Enums } from '../common/enums'
import { DataProvider } from '../../helpers/data-provider'

import { OpDescr } from '../../models/core/op-descr'


export class OpAlarmType implements IReferenceType, IOpChangeState, IJsonSerializable {
    //Properties
    public idAlarmType: number
    public symbol: string
    public idDescr: number
    //Properties end
    //NavigationProperties
    public descr: OpDescr
    //NavigationProperties end
    //CustomProperties
    //CustomProperties end

    constructor(opObj: any) {
        this.fromJSON(opObj)
    }

    //IOpChangeState implementation
    public opState: Enums.OpChangeState
    //IOpChangeState implementation end
    //IReferenceType implementation
    public getReferenceType(): Enums.ReferenceType {
        return Enums.ReferenceType.IdAlarmType
    }
    public getReferenceKey(): number {
        return this.idAlarmType
    }
    public getReferenceValue(): any {
        return this
    }
    //IReferenceType implementation end

    
    public fromJSON(opObj: any, compressed: boolean = false): void {

        if (opObj) {
            if (compressed || (opObj && opObj.__IC && opObj.__IC == 1)) {
                this.idAlarmType = opObj.IT
                this.symbol = opObj.S
                this.idDescr = opObj.I
                this.descr = opObj.D ? new OpDescr(opObj.D) : null
            } else {
                this.idAlarmType = opObj.ID_ALARM_TYPE
                this.symbol = opObj.SYMBOL
                this.idDescr = opObj.ID_DESCR
                this.descr = opObj._Descr ? new OpDescr(opObj._Descr) : null
            }
        }
    }

    public toJSON(compressed: boolean = false): any {
        if (compressed) {
            return {
                IT: this.idAlarmType,
                S: this.symbol,
                I: this.idDescr,
                D: this.descr != null ? this.descr.toJSON(compressed) : null,
                __IC: 1
            }
        } else {
            return {
                ID_ALARM_TYPE: this.idAlarmType,
                SYMBOL: this.symbol,
                ID_DESCR: this.idDescr,
                _Descr: this.descr != null ? this.descr.toJSON(compressed) : null,
            }
        }
    }

    public toString() {
        if (this.descr)
            return this.descr.toString() + "[" + this.symbol + "]"
        return this.symbol
    }

    public static loadNavigationProperties(dataProvider: DataProvider, list: OpAlarmType[]) {
        var defered = $.Deferred<OpAlarmType[]>()

        defered.resolve(list)

        return defered.promise()
    }
}